import {requirePermission} from '@/modules/auth/permissions'
import {createFileRoute, redirect} from '@tanstack/react-router'

export const Route = createFileRoute('/configuration/smart-compounders/')({
  beforeLoad: () => {
    requirePermission('interfaces.manage')()
    throw redirect({to: '/configuration/smart-compounders/mappings'})
  },
})
